import { defineMessages } from 'react-intl';

export default defineMessages({
  managerInboxesEmptyStateTitle: {
    id: 'manager_inboxes.empty_state.title',
  },
  managerInboxesEmptyStateDescription: {
    id: 'manager_inboxes.empty_state.description',
  },
  fieldSearchInboxes: {
    id: 'manager_inboxes.field_search.title',
  },
  assignedUsersTitle: {
    id: 'manager_inboxes.assigned_users',
  },
  assignedTasksTitle: {
    id: 'manager_inboxes.assigned_task',
  },
  unassignedTaskTitle: {
    id: 'manager_inboxes.not_assigned_task.title',
  },
  confirmationDialogTitle: {
    id: 'manager_inboxes.confirmation.dialog.title',
  },
  confirmationDialogDescription: {
    id: 'manager_inboxes.confirmation.dialog.description',
  },
  confirmationDialogConfirmButton: {
    id: 'manager_inboxes.confirmation.dialog.confirm',
  },
  confirmationDialogCancelButton: {
    id: 'manager_inboxes.confirmation.dialog.cancel',
  },
  successToastUnassignedManager: {
    id: 'manager_inboxes.success.unassigned_manager.toast',
  },
  selectButtonTitle: {
    id: 'manager_inboxes.select_button.title',
  },
  unassignedButtonTitle: {
    id: 'manager_inboxes.unassigned_button.title',
  },
  cancelSelectionTitle: {
    id: 'manager_inboxes.unassigned_manager.cancel_title',
  },
  assignButtonTitle: {
    id: 'manager_inboxes.assigned_button.title',
  },
  unassignedManagerDialogTitle: {
    id: 'manager_inboxes.unassigned_manager.confirmation_dialog.dialog',
  },
  selectAllUnassignedManagerTitle: {
    id: 'manager_inboxes.unassigned_manager.select_title',
  },
  searchField: {
    id: 'manager_inboxes.search_field.title',
  },
  busierTitle: {
    id: 'manager_inboxes.assigned_head.busier',
  },
  lessBusyTitle: {
    id: 'manager_inboxes.assigned_head.less_busy',
  },
  claimSubTitle: {
    id: 'inboxe.sub_title.claim.title',
  },
  managersSubTitle: {
    id: 'inboxe.sub_title.manager.title',
  },
  claimPendingSubTitle: {
    id: 'inboxe.sub_title.claim_pending.title',
  },
  alphabeticalOrder: {
    id: 'manager_inboxes.assigned_head.alphabetical_order',
  },
  openingManager: {
    id: 'attribution.opening_manager',
  },
  courtManager: {
    id: 'attribution.court_manager',
  },
  monitoringManager: {
    id: 'attributions.monitoring_manager',
  },
  solhFelHinManager: {
    id: 'attributions.solhfilhin_manager',
  },
  preopenManager: {
    id: 'attributions.preopen_manager',
  },
  otherManagers: {
    id: 'attributions.other_managers',
  },
  transactionManager: {
    id: 'attributions.transaction_manager',
  },
  isPriorityClaimManager: {
    id: 'attributions.is_priority_claim_manager',
  },
});
